import React from 'react';
import PlanTypeCard from '../PlanTypeCard';
import * as styles from './styles/styles.module.scss';
import CurrencyCode from 'types/CurrencyCode';
import PlanTypeType from 'types/PlanTypeType';
import PlanCode from 'types/PlanCode';

type Props = {
  planTypes: PlanTypeType[];
  handler?(...args: unknown[]): unknown;
  activePlanType?: PlanCode;
  currencyCode: CurrencyCode;
  isCouponApplied?: boolean;
  verifiedCoupon?: any;
};

const PlanTypeCardCollection = ({ planTypes, handler, activePlanType, currencyCode, verifiedCoupon, isCouponApplied }: Props) => (
  <>
    {planTypes.map(option => (
      <PlanTypeCard
        data-testid={`plan-${option.planCode}`}
        key={`plan-${option.planCode}`}
        plan={option}
        onClick={() => handler(option.planCode)}
        isActive={activePlanType === option.planCode}
        currencyCode={currencyCode}
        verifiedCoupon={verifiedCoupon}
        isCouponApplied={isCouponApplied}
        extraClasses={`${styles.card}`}
      />
    ))}
  </>
);

export default PlanTypeCardCollection;
